import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import useCategories from "../../../../utils/useCategories";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import {
  clearSchedulesTxnErrors,
  schedulesTxnApproval,
  schedulesTxnDelete,
  schedulesTxnDetail,
  scheduleTxnOccurrences,
} from "../../../../redux/features/scheduleTransaction";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import CommonToast from "../../../../components/_utils/CommonToast";
import ICONS from "../../../../assets/Icons";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton";
import globalText from "../../../../utils/globalText";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard";
import {
  formatDate,
  formatTimeSlot,
} from "../../../../components/ScheduleTransactions/helpers";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { beneTxnViewAllAcc } from "../../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import Loader from "../../../../components/Loader/Index";
import BeneTransactionGridView from "../../../../components/Transactions/BeneTrasnaction/BeneTransactionGridView";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import ScheduleTxnOccurrencesPopup from "../../../../components/ScheduleTransactions/ScheduleTxnOccurrencesPopup";
import BeneScheduleTxnDeclinePopup from "../../../../components/_utils/TransactionCommonComponents/CommonDeclinePopups/BeneScheduleTxnDeclinePopup";
import MediumImagePopup from "../../../../components/_utils/MediumImagePopup";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import TimelinePopupContent from "../../../../components/_utils/TimelinePopupContent";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo";
import PrimaryWithIconButton from "../../../../components/_utils/CommonButtons/PrimaryWithIconButton";
import CommonTimeLineCard, {
  addLifeCycleStatus,
} from "../../../../components/CommonTimeLineCard";
import PositiveNegativeButton from "../../../../components/_utils/CommonButtons/PositiveNegativeButton";
import TimelineStatusBar from "../../../../components/_utils/TimelineCommonComponents/TimelineStatusBar";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs";
import ScheduleTransactionViewAllPopup from "../../../../components/Transactions/ScheduleBeneTransaction/ScheduleBeneTransactionViewAllPopup";
import BeneAccountDetailsPopup from "../../../../components/Accounts/BeneAccount/BeneAccountDetailsPopup";

const ScheduleBeneficiaryTransactionDetails = ({
  isPopup,
  txn_id,
  detailSelected,
  preApproveAdvice,
  postApproveAdvice,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const paramId = useParams().id;
  const cardRefs = useRef({});
  const leftContentRef = useRef(null);
  const categoryMapper = useCategories();
  const id = txn_id ?? paramId;
  const [isOpen, setIsOpen] = useState(false);
  const [isloading, setIsLoading] = useState(true);
  const [scheduleId, setScheduleId] = useState("");
  const [btnClicked, setbtnClicked] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [scheduleAmt, setScheduleAmt] = useState("");
  const [scheduleName, setScheduleName] = useState("");
  const [doneBinding, setDoneBinding] = useState(false);
  const [scheduleSrcId, setScheduleSrcId] = useState("");
  const [rightHeight, setRightHeight] = useState("auto");
  const [selectedImage, setSelectedImage] = useState({});
  const [openImageUrl, setOpenImageUrl] = useState(false);
  const [animationClass, setAnimationClass] = useState("");
  const [scheduleBeneId, setScheduleBeneId] = useState("");
  const [scheduleSrcIFSC, setScheduleSrcIFSC] = useState("");
  const [scheduleEndDate, setScheduleEndDate] = useState("");
  const [transactionData, setTransactionData] = useState([]);
  const [scheduleCategory, setScheduleCategory] = useState("");
  const [scheduleBeneName, setScheduleBeneName] = useState("");
  const [scheduleBeneIFSC, setScheduleBeneIFSC] = useState("");
  const [scheduleTimeSlot, setScheduleTimeSlot] = useState("");
  const [showPromptModal, setShowPromptModal] = useState(false);
  const [scheduleDeleted, setScheduleDeleted] = useState(false);
  const [scheduleFrequency, setScheduleFrequency] = useState("");
  const [scheduleStartDate, setScheduleStartDate] = useState("");
  const [scheduleCreatedOn, setScheduleCreatedOn] = useState("");
  const [scheduleCreatedBy, setScheduleCreatedBy] = useState("");
  const [scheduleLifecycle, setScheduleLifecycle] = useState("");
  const [showBeneAccModal, setShowBeneAccModal] = useState(false);
  const [showRejectPrompt, setShowRejectPrompt] = useState(false);
  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);
  const [scheduleOccurrences, setScheduleOccurrences] = useState("");
  const [scheduleBeneTxnList, setScheduleBeneTxnList] = useState([]);
  const [isScheduleRejected, setIsScheduleRejected] = useState(false);
  const [isScheduleApproved, setIsScheduleApproved] = useState(false);
  const [scheduleUpdatedData, setScheduleUpdatedData] = useState(null);
  const [scheduleSrcAcctNumber, setScheduleSrcAcctNumber] = useState("");
  const [scheduleRejectMessage, setScheduleRejectMessage] = useState("");
  const [schedulePaymentMethod, setSchedulePaymentMethod] = useState("");
  const [currentlyShownDetail, setCurrentlyShownDetail] = useState(<></>);
  const [showOccurrencesModal, setShowOccurrencesModal] = useState(false);
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);
  const [scheduleBeneApproved, setScheduleBeneApproved] = useState(false);
  const [scheduleBeneAcctNumber, setScheduleBeneAcctNumber] = useState("");
  const [scheduleApproveFailed, setScheduleApproveFailed] = useState(false);
  const [scheduleOccurrenceDates, setScheduleOccurrenceDates] = useState([]);
  const [isScheduleConfidential, setIsScheduleConfidential] = useState(false);
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const [pageSize, setPageSize] = useState(dropdownOptions[0]);
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const [selectedDetail, setSelectedDetail] = useState(
    detailSelected ?? "Details",
  );

  const [scheduleApproveFailedMessage, setScheduleApproveFailedMessage] =
    useState("");
  const [scheduleAppRejLoaderShow, setScheduleAppRejLoaderShow] =
    useState(false);
  const [showScheduleHistoryPopup, setShowScheduleHistoryPopup] =
    useState(false);
  const [showScheduleConfidentialPopup, setShowScheduleConfidentialPopup] =
    useState(false);
  const [showScheduleCategoryPopup, setShowScheduleCategoryPopup] =
    useState(false);
  const [index, setIndex] = useState(
    selectedDetail === "Details"
      ? GlobalConfiguration?.lengthCheckZero
      : selectedDetail === "Additional details"
        ? GlobalConfiguration?.lengthCheckOne
        : selectedDetail === "Transaction created"
          ? GlobalConfiguration?.lengthCheckTwo
          : GlobalConfiguration?.lengthCheckZero,
  );

  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );

  const {
    schedulesTxnDetailData,
    schedulesTxnDeleteLoading,
    schedulesTxnDeleteError,
    schedulesTxnRejectError,
  } = useSelector((s) => s.schedulesTxn);
  const services = useSelector((state) => state.refreshToken.services);
  const { schedulesTxnDetailLoading } = useSelector((s) => s.schedulesTxn);
  const hasModService = services?.includes("BAScheduledTxn");
  const hasOccurrenceService = services?.includes("BOScheduledTxn");
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState(
    Array(
      schedulesTxnDetailData?.[0]?.logs?.length ||
        GlobalConfiguration?.lengthCheckZero,
    ).fill(false),
  );

  const handleBeneAccModalClose = () => {
    setShowBeneAccModal(false);
    dispatch(
      schedulesTxnDetail({
        id,
        services,
        navigate,
      }),
    );
  };

  const handleScheduleDiscard = () => {
    (async () => {
      UniversalRefreshToast("Discarding schedule");
      let a = await dispatch(
        schedulesTxnDelete({ id: scheduleId, navigate, services }),
      );
      if (a?.payload?.status ?? false) {
        toast.dismiss();
        setTimeout(() => {
          CommonToast({
            text: "Schedule discarded successfully.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
          });
        }, 2500);
        setShowPromptModal(false);
        setScheduleDeleted(true);
      } else {
        CommonToast({
          text: schedulesTxnDeleteError,
          icon: ICONS?.INFO_FILLED,
          variant: "var(--error)",
        });
        setShowPromptModal(false);
      }
      dispatch(
        schedulesTxnDetail({
          id,
          services,
          navigate,
        }),
      );
    })();
  };

  const warnPopupRestricted = (msg = "Action restricted in popup mode.") =>
    CommonToast({
      text: msg,
      icon: ICONS?.ERROR_WHITE_CIRCLE,
      variant: "var(--error)",
      btnProps: {
        isDisabled: false,
        enabledTextColor: "var(--text-primary)",
        enabledBgColor: "var(--primary-bg)",
      },
    });

  const runIfNotPopup =
    (fn, warnMsg) =>
    (...args) => {
      if (isPopup) {
        warnPopupRestricted(warnMsg);
        return;
      }
      if (typeof fn === "function") return fn(...args);
    };

  const safeSetShowPromptModal = () => {
    if (isPopup) {
      warnPopupRestricted();
      return;
    }
    setShowPromptModal(true);
  };

  const handleSelect = (value) => {
    setCurrentPage(1);
    setSelectedValue(value);
    setPageSize(value);
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const handleShowOccurrences = () => {
    (async () => {
      let response = await dispatch(
        scheduleTxnOccurrences({
          paramsData: {
            frequency: scheduleFrequency,
            transaction_start_date: scheduleStartDate,
            transaction_end_date: scheduleEndDate,
          },
          services,
          navigate,
        }),
      );
      setScheduleOccurrenceDates(response?.payload?.dates ?? []);
      setShowOccurrencesModal(true);
    })();
  };

  const handleApprove = () => {
    (async () => {
      setbtnClicked((prev) => ({
        ...prev,
        [scheduleId]: "Approve",
      }));
      setScheduleAppRejLoaderShow(true);
      UniversalRefreshToast("Approving schedule");

      preApproveAdvice?.call();
      const response = await dispatch(
        schedulesTxnApproval({ id: scheduleId, services, navigate }),
      );
      if (response?.payload?.status ?? false) {
        toast.dismiss();
        setIsScheduleApproved(true);
        setScheduleLifecycle("approved");
        setTimeout(() => {
          CommonToast({
            text: "Schedule approved successfully.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
          });
        }, 2500);
        if (isPopup) {
          setTimeout(() => {
            setShowRejectPrompt(false);
            window.location.reload();
          }, GlobalConfiguration?.autoCloseTime);
        }
      } else {
        setbtnClicked((prev) => ({
          ...prev,
          [scheduleId]: "none",
        }));
        setScheduleApproveFailed(true);
        setScheduleApproveFailedMessage(
          response?.payload?.errors?.base?.[0]?.errors?.[0] ??
            "Something went wrong while rejecting transaction",
        );
        toast.dismiss();

        CommonToast({
          text: response?.payload?.errors?.base?.[0]?.errors?.[0],
          icon: ICONS?.INFO_FILLED,
          variant: "var(--error)",
        });
        setbtnClicked((prev) => ({
          ...prev,
          [scheduleUpdatedData?.[0]?.txn_id]: "none",
        }));
      }
      postApproveAdvice?.call();
      setScheduleAppRejLoaderShow(false);
    })();
  };

  const onApproveClick = () => {
    if (hasModService) {
      setbtnClicked((prev) => ({
        ...prev,
        [scheduleId]: "Approve",
      }));
      handleApprove();
    } else {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "BAScheduledTxn" },
      });
    }
  };

  const quickActions = (
    <>
      <div className="text-text-primary text-font-xxs bottom-bottom-base w-max-width-list-status-lg hidden Qsmd:flex flex-col items-end absolute z-z-index-content">
        <div className="w-full h-full" />
        <div
          className="flex flex-row"
          style={{ borderTop: "var(--border) solid var(--primary-bg)" }}
        ></div>
      </div>

      <div className="flex Qsmd:hidden flex-col text-text-primary">
        <div className="bg-primary-card p-padding-sm text-text-secondary text-font-sm font-semibold mt-margin-md">
          Quick actions
        </div>

        <div className="bg-primary-nav-act text-font-xs">
          <div className="flex flex-wrap border-t border-primary-bg">
            <div className="w-1/2 border-r border-b border-primary-bg">
              <TopNavSmallButton
                btnText={scheduleCategory}
                btnType="button"
                handleFunction={runIfNotPopup(() =>
                  setShowScheduleCategoryPopup(true),
                )}
                isDisabled={isPopup}
                enabledTextColor="var(--text-primary)"
                enabledBgColor="var(--primary-nav-act)"
                disabledBgColor="var(--primary-nav-act)"
                icon={categoryMapper(scheduleCategory)}
                hoverOption="white"
                fullWidthRequired={true}
              />
            </div>

            <div className="w-1/2 border-b border-primary-bg">
              <TopNavSmallButton
                btnText={
                  <>
                    {globalText?.SCHEDULE} <br /> {globalText?.HISTORY}
                  </>
                }
                btnType="button"
                handleFunction={runIfNotPopup(() =>
                  setShowScheduleHistoryPopup(true),
                )}
                isDisabled={isPopup}
                enabledTextColor="var(--text-primary)"
                enabledBgColor="var(--primary-nav-act)"
                disabledBgColor="var(--primary-nav-act)"
                icon={ICONS?.TRANSACTION_HISTORY}
                hoverOption="white"
                fullWidthRequired={true}
              />
            </div>

            {isScheduleConfidential && (
              <div
                className={`border-r border-primary-bg ${
                  !scheduleDeleted ? "w-1/2" : "w-full"
                }`}
              >
                <TopNavSmallButton
                  btnText={
                    <>
                      {globalText?.CONFIDENTIAL}
                      <br />
                      {globalText?.TRANSACTION}
                    </>
                  }
                  btnType="button"
                  handleFunction={runIfNotPopup(() =>
                    setShowScheduleConfidentialPopup(true),
                  )}
                  isDisabled={isPopup}
                  enabledTextColor="var(--text-primary)"
                  enabledBgColor="var(--primary-nav-act)"
                  disabledBgColor="var(--primary-nav-act)"
                  icon={ICONS?.CONFIDENTIAL_TRANSACTION}
                  hoverOption="white"
                  fullWidthRequired={true}
                />
              </div>
            )}

            {!scheduleDeleted && (
              <div
                className={` ${isScheduleConfidential ? "w-1/2" : "w-full"}`}
              >
                <TopNavSmallButton
                  btnText={
                    <>
                      {globalText?.DISCARD} <br /> {globalText?.SCHEDULE}
                    </>
                  }
                  btnType="button"
                  handleFunction={runIfNotPopup(() => {
                    if (hasModService) {
                      safeSetShowPromptModal();
                    } else {
                      navigate("/feature_not_assigned", {
                        state: { unavailableService: "IAScheduledTxn" },
                      });
                    }
                  })}
                  isDisabled={isPopup || !hasModService}
                  enabledTextColor="var(--text-primary)"
                  enabledBgColor="var(--primary-nav-act)"
                  disabledBgColor="var(--primary-nav-act)"
                  icon={ICONS?.DISCARD_WITH_WHITE_CIRCLE}
                  hoverOption="white"
                  fullWidthRequired={true}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );

  const normalizeAdditionalDetails = (details = []) => {
    return details.map((item) => {
      const hasValue =
        item.hasOwnProperty("value") &&
        item.value !== null &&
        item.value !== "" &&
        !(
          Array.isArray(item.value) &&
          item.value.length === GlobalConfiguration?.lengthCheckZero
        );

      return {
        ...item,
        value: hasValue ? item.value : "Not given",
      };
    });
  };

  const allAdditionalData =
    schedulesTxnDetailData?.transaction?.flatMap((txn) =>
      normalizeAdditionalDetails(txn?.additional_data?.data ?? []),
    ) || [];

  const nonAttachmentDetails = allAdditionalData.filter(
    (item) => !["hyperlink", "upload"].includes(item.data_type),
  );

  const attachments = allAdditionalData.filter((item) =>
    ["hyperlink", "upload"].includes(item.data_type),
  );

  const detailSectionAdditionalDetailsDiv = (
    <div className={animationClass}>
      <div className="flex flex-col Qmd:flex-row items-start gap-gap-md pb-padding-md text-text-primary">
        {nonAttachmentDetails?.length > GlobalConfiguration?.lengthCheckZero ? (
          <CommonDetailCard
            cardTitle="Additional details"
            variant="third"
            numCols={
              nonAttachmentDetails.length ===
              GlobalConfiguration?.lengthCheckOne
                ? GlobalConfiguration?.lengthCheckOne
                : GlobalConfiguration?.lengthCheckTwo
            }
            entries={nonAttachmentDetails.map((item) => {
              switch (item.data_type) {
                case "from_year_to_year":
                  return {
                    heading: item.name,
                    content:
                      item.value?.from && item.value?.to
                        ? `${item.value.from} - ${item.value.to}`
                        : "Not given",
                    type: "text",
                  };

                case "date_range":
                  return {
                    heading: item.name,
                    content:
                      item.value?.start_date && item.value?.end_date
                        ? `${item.value.start_date} - ${item.value.end_date}`
                        : "Not given",
                    type: "text",
                  };

                case "multi_select_list":
                  return {
                    heading: item.name,
                    content:
                      Array.isArray(item.value) && item.value.length
                        ? item.value.join(", ")
                        : "Not given",
                    type: "text",
                  };

                case "toggle":
                  return {
                    heading: item.name,
                    content: item.value === true ? "Yes" : "No",
                    type: "text",
                  };

                default:
                  return {
                    heading: item.name,
                    content: item.value || "Not given",
                    type: "text",
                  };
              }
            })}
          />
        ) : (
          <CommonDetailCard
            cardTitle="Additional details"
            variant="third"
            numCols={GlobalConfiguration?.lengthCheckOne}
            entries={[
              {
                content:
                  "Additional details are not supported for the selected category.",
              },
            ]}
          />
        )}

        {attachments.length > GlobalConfiguration?.lengthCheckZero && (
          <>
            <CommonDetailCard
              cardTitle={globalText?.ATTACHMENTS}
              numCols={GlobalConfiguration?.lengthCheckOne}
              variant="third"
              entries={attachments.map((obj, index) => {
                switch ((obj.data_type || "").toLowerCase()) {
                  case "hyperlink": {
                    const isValid =
                      obj?.value &&
                      obj.value !== "Not given" &&
                      obj.value !== "#" &&
                      obj.value !== "";

                    return {
                      content: isValid ? obj.value : "Not given",
                      heading: "URL",
                      type: isValid ? "link" : "text",
                    };
                  }

                  default: {
                    const ob = obj?.value;
                    if (!ob || ob === "Not given" || typeof ob !== "object") {
                      return {
                        heading: "File",
                        content: "Not given",
                        type: "text",
                      };
                    }

                    const mimeType =
                      ob?.metadata?.mime_type || "application/octet-stream";

                    const fileName = ob?.metadata?.filename || "Unknown file";
                    const size = ob?.metadata?.size ?? "0";
                    const fileUrl = ob?.file_url;

                    if (!fileUrl) {
                      return {
                        heading: "File",
                        content: "Not given",
                        type: "text",
                      };
                    }

                    if (mimeType.startsWith("image/")) {
                      return {
                        heading: "Image",
                        type: "image",
                        content: {
                          fileName,
                          size,
                          mimeType,
                          url: fileUrl,
                          onUrlClick: () => {
                            setOpenImageUrl(true);
                            setSelectedImage({
                              name: fileName,
                              url: fileUrl,
                            });
                          },
                        },
                      };
                    }

                    return {
                      heading: "File",
                      type: "file",
                      content: {
                        fileName,
                        size,
                        mimeType,
                        url: fileUrl,
                        onUrlClick: () => {
                          window.open(fileUrl, "_blank")?.focus();
                        },
                      },
                    };
                  }
                }
              })}
            />
          </>
        )}
      </div>
    </div>
  );

  const detailSectionDetailsDiv = (
    <div className="flex flex-col items-center Qmd:items-start Qmd:flex-row gap-gap-md pb-padding-md Qmd:pb-padding-base">
      <CommonDetailCard
        cardTitle="Transfer details"
        variant="third"
        numCols={1}
        entries={[
          {
            content: [scheduleFrequency.split("_").join(" ")].map(
              (s) => s.charAt(0).toUpperCase() + s.slice(1),
            ),
            heading: "Frequency",
            type: "text",
          },
          {
            content: formatDate(scheduleStartDate),
            heading: "Schedule start date",
            type: "text",
          },
          {
            content: formatDate(scheduleEndDate),
            heading: "Schedule end date",
            type: "text",
          },
          {
            content: formatTimeSlot(scheduleTimeSlot),
            heading: "Time slot",
            type: "text",
          },
          {
            content: scheduleOccurrences,
            heading: "Occurrences",
            onClick: () => {
              if (isPopup) {
                CommonToast({
                  text: "Action restricted in popup mode.",
                  icon: ICONS?.ERROR_WHITE_CIRCLE,
                  variant: "var(--error)",
                  btnProps: {
                    isDisabled: false,
                    enabledTextColor: "var(--text-primary)",
                    enabledBgColor: "var(--primary-bg)",
                  },
                });
              } else if (hasOccurrenceService) {
                handleShowOccurrences();
              } else {
                navigate("/feature_not_assigned", {
                  state: {
                    unavailableService: "BOScheduledTxn",
                  },
                });
              }
            },
            isDisabled: !hasOccurrenceService || isPopup,
            type: "text",
          },
        ]}
      />

      <CommonDetailCard
        cardTitle="Origin details"
        variant="third"
        numCols={1}
        entries={[
          {
            content: scheduleCreatedBy,
            heading: "Created by",
            type: "text",
          },
          {
            content: formatDateViewAll(scheduleCreatedOn, true, true),
            heading: "Created on",
            type: "text",
          },
        ]}
      />
    </div>
  );

  useEffect(() => {
    if (isPopup) {
      setSelectedDetail("Additional details");
      setIndex(1);
    }
  }, [isPopup]);

  const handleShowDetails = () => {
    setSelectedDetail("Details");
    setIndex(0);
  };

  const handleShowAdditionalDetails = () => {
    setSelectedDetail("Additional details");
    setIndex(1);
  };

  const handleTransactionCreated = () => {
    setSelectedDetail("Transaction created");
    setIndex(2);
  };

  const handleTimelinePopup = () => {
    if (isPopup) {
      CommonToast({
        text: "Action restricted in popup mode.",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    } else {
      SetopenTimelinePopup(true);
      setShowApprovalTimeline(true);
    }
  };

  const PopupcloseIcons = () => {
    setOpenApprovalTimeline([]);
    SetopenTimelinePopup(false);
    setShowApprovalTimeline(false);
  };
  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });

    if (!openApprovalTimeline[index]) {
      setTimeout(() => {
        cardRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, IntervalConfiguration.intervalExtraSmall);
    }
  };

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index, prevIndex]);

  useEffect(() => {
    if (!leftContentRef.current) return;
    const updateHeight = () => {
      setRightHeight(leftContentRef.current.offsetHeight);
    };
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [
    schedulesTxnDetailData,
    scheduleLifecycle,
    isScheduleApproved,
    isScheduleRejected,
    scheduleDeleted,
  ]);

  useEffect(() => {
    setIsLoading(true);
    setScheduleUpdatedData(schedulesTxnDetailData);
    setIsLoading(false);
    return () => {
      dispatch(clearSchedulesTxnErrors());
    };
  }, [schedulesTxnDetailData]);

  useEffect(() => {
    dispatch(disableSwitcher());
    (async () => {
      if (services) {
        dispatch(
          schedulesTxnDetail({
            id,
            services,
            navigate,
          }),
        );
      }
    })();
  }, []);

  useEffect(() => {
    setDoneBinding(false);
    if (
      Array.isArray(scheduleUpdatedData?.transaction) &&
      scheduleUpdatedData.transaction.length
    ) {
      let data = scheduleUpdatedData?.transaction[0];
      setScheduleId(data?.txn_id ?? "");
      setScheduleName(data?.scheduled_name ?? "Not available");
      setScheduleAmt(data?.amount ?? "0");
      setSchedulePaymentMethod(data?.payment_method ?? "");
      setScheduleCategory(data?.category ?? "");
      setScheduleDeleted((data?.deleted ?? "N") === "Y");
      setScheduleFrequency(data?.frequency ?? "");
      setScheduleStartDate(data?.transaction_start_date ?? "1970-1-1");
      setScheduleEndDate(data?.transaction_end_date ?? "1970-1-1");
      setScheduleTimeSlot(data?.slot ?? " - ");
      setScheduleOccurrences(data?.occurrences ?? "0");
      setScheduleCreatedOn(data?.created_on ?? "");
      setScheduleCreatedBy(data?.txn_initiator ?? "");
      setScheduleLifecycle(data?.lifecycle_status ?? "pending");
      setIsScheduleRejected(data?.rejected === "Y" || data?.rejected === true);
      setScheduleRejectMessage(data?.rejection_reason ?? "");
      setIsScheduleApproved((data?.approved ?? "N") === "Y");
      setIsScheduleConfidential(
        (data?.confidential_transaction ?? "N") === "Y",
      );
      setScheduleSrcAcctNumber(data?.owner_account_bank_acc_no ?? "");
      setScheduleSrcIFSC(data?.owner_account_ifsc_code ?? "");
      setScheduleSrcId(data?.owner_account_id ?? "");
      setScheduleBeneAcctNumber(data?.beneficiary_account_bank_acc_no ?? "");
      setScheduleBeneIFSC(data?.beneficiary_account_ifsc_code ?? "");
      setScheduleBeneId(data?.beneficiary_account_id ?? "");
      setScheduleBeneApproved(
        (data?.beneficiary_account_approval_status ?? "pending") !== "pending",
      );
      setScheduleBeneName(data?.beneficiary_account_name ?? "");
      setScheduleBeneTxnList(data?.beneficiary_transaction_ids ?? []);
      setDoneBinding(true);
    }
  }, [scheduleUpdatedData]);

  useEffect(() => {
    const handleFetch = async () => {
      setIsLoading(true);
      let data = await dispatch(
        beneTxnViewAllAcc({
          page_item_count: pageSize,
          page_no: currentPage,
          txn_id: scheduleBeneTxnList || [],
        }),
      );
      setIsLoading(false);
      setTransactionData(data);
    };
    if (scheduleBeneTxnList?.length) {
      handleFetch();
    }
  }, [scheduleBeneTxnList, currentPage, pageSize]);

  useEffect(() => {
    let detail = <></>;
    switch (selectedDetail) {
      default:
      case "Details":
        detail = detailSectionDetailsDiv;
        break;
      case "Additional details":
        detail = detailSectionAdditionalDetailsDiv;
        break;
      case "Transaction created":
        detail = (
          <>
            <div className="flex flex-col Qmd:flex-row gap-y-gap-md gap-x-gap-sm flex-wrap pb-padding-md">
              {schedulesTxnDetailLoading ? (
                <div className="w-width-full flex justify-center items-center">
                  <Loader />
                </div>
              ) : (
                <BeneTransactionGridView
                  data={transactionData?.payload?.transactions}
                  typepop={"schedDetailViewAll"}
                />
              )}
            </div>
            <div className="h-height-full" />
          </>
        );
        break;
    }
    setCurrentlyShownDetail(detail);
  }, [
    selectedDetail,
    doneBinding,
    transactionData,
    isloading,
    scheduleUpdatedData,
  ]);

  useEffect(() => {
    if (
      showOccurrencesModal ||
      showPromptModal ||
      showRejectPrompt ||
      showBeneAccModal
    ) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [
    showOccurrencesModal,
    showPromptModal,
    showRejectPrompt,
    showBeneAccModal,
  ]);

  useEffect(() => {
    if (schedulesTxnDetailData) {
      const uiState = addLifeCycleStatus({
        lifecycle_status:
          schedulesTxnDetailData?.transaction[0]?.lifecycle_status,
        services,
      });
      const newData = {
        ...schedulesTxnDetailData,
        transaction: schedulesTxnDetailData?.transaction?.map((account) => ({
          ...account,
          loading: false,
          error: false,
          message: "",
          last_updated_user_id_check: false,
          statusName: uiState.statusName,
          statusColor: uiState.statusColor,
          distributionStatusName: uiState.distributionStatusName,
          distributionStatusColor: uiState.distributionStatusColor,
          barColor: uiState.barColor,
          barValue: uiState.barValue,
        })),
      };
      setScheduleUpdatedData(newData);
      setScheduleId(schedulesTxnDetailData?.transaction[0]?.txn_id);
    }
    setDoneBinding(true);
  }, [schedulesTxnDetailData]);

  return !doneBinding || schedulesTxnDetailLoading ? (
    <>
      <div className="w-width-full h-full-height flex flex-row justify-center items-center">
        <Loader />
      </div>
    </>
  ) : (
    <div className="flex flex-col h-full-height overflow-y-auto">
      {showPromptModal && (
        <div className="fixed z-z-index-max flex  items-center justify-center  top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle="Discard schedule"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext="Are you sure you want to discard this schedule?"
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              setShowPromptModal(false);
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Discard"
            btnTwoHandleFunction={handleScheduleDiscard}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
            /* loader */
            btnTwoLoading={schedulesTxnDeleteLoading ?? false}
          />
        </div>
      )}
      {showOccurrencesModal && (
        <ScheduleTxnOccurrencesPopup
          closeCallback={() => setShowOccurrencesModal(false)}
          occurrences={scheduleOccurrenceDates}
        />
      )}
      {showRejectPrompt && (
        <BeneScheduleTxnDeclinePopup
          allTxnData={scheduleUpdatedData?.transaction}
          handleClose={() => {
            setShowRejectPrompt(false);
            setbtnClicked((prev) => ({
              ...prev,
              [scheduleId]: "none",
            }));
          }}
          txnId={scheduleId}
          updateAllTxn={(updatedData) => {
            setScheduleUpdatedData((prev) => ({
              ...prev,
              transaction: updatedData,
            }));
          }}
          onRejectSuccess={() => {
            setShowRejectPrompt(false);
            window.location.reload();
          }}
          type="beneScheduleTxnDetail"
          toastType="singleSchedule"
        />
      )}

      {openImageUrl && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <MediumImagePopup
              image={selectedImage}
              closehandleFunction={() => {
                setOpenImageUrl(false);
              }}
            />
          </div>
        </>
      )}

      {opentimelinepopup && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle="Schedule timeline"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headertextSize="font-md"
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={PopupcloseIcons}
              closeicon={ICONS?.CLOSE}
              closeiconhoverOption="white"
              closeiconbtnType={"button"}
              closeiconisDisabled={false}
              closeicondisabledBgColor={""}
              closeiconbuttonRef={null}
              closeicontitle={"Close"}
              btnType={"button"}
              handleFunction={() => {}}
              enabledBgColor={"var(--positive-act)"}
              hoverOption={"dark"}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
              fullWidthRequired={false}
              isDisabled={false}
              disabledTextColor={""}
              disabledBgColor={""}
              isLoading={false}
              buttonRef={null}
              inActiveVariantNeeded={false}
              isLoaderNeeded={false}
              isscrollRequired={true}
            >
              <TimelinePopupContent
                logsData={scheduleUpdatedData?.transaction}
                handleApprovalClick={handleTimelinePopup}
                showDistributionRightIcon={false}
                showApprovalLeftIcon={false}
                showApprovalTimeline={showApprovalTimeline}
                openApprovalTimeline={openApprovalTimeline}
                handleApprovalTimeline={handleApprovalTimeline}
                setOpenApprovalTimeline={setOpenApprovalTimeline}
                cardType={"single"}
                popUpMode={true}
              />
            </LargePopupRedirect>
          </div>
        </>
      )}
      {showBeneAccModal && (
        <div
          className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-light-opacity"
          onClick={() => {
            handleBeneAccModalClose();
          }}
        >
          <BeneAccountDetailsPopup
            closeBeneAccountDetailModal={handleBeneAccModalClose}
            bene_account_id={scheduleBeneId}
            type={"bene_account_detail_modal"}
          />
        </div>
      )}
      {transactionData?.payload?.transactions?.length >
        GlobalConfiguration?.lengthCheckZero &&
        selectedDetail === "Transaction created" && (
          <div
            style={{
              zIndex: "var(--z-index-modal)",
              width: "var(--width-full)",
              bottom: "var(--bottom-base)",
              borderRadius: "var(--rounded-none)",
            }}
            className="bg-primary-nav h-pagination-height fixed w-width-full"
          >
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={transactionData?.payload}
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={currentPage}
              setIsOpen={setIsOpen}
            />
          </div>
        )}

      {showScheduleHistoryPopup && (
        <ScheduleTransactionViewAllPopup
          title={"Schedule history"}
          subtitle={
            "All scheduled transaction related to beneficiary are listed below."
          }
          closeCallback={() => setShowScheduleHistoryPopup(false)}
          type={"history"}
          payload={{
            id: scheduleBeneId,
            number: scheduleBeneAcctNumber,
            name: scheduleBeneName,
            schedule_acc_name: scheduleBeneName,
          }}
        />
      )}
      {showScheduleCategoryPopup && (
        <ScheduleTransactionViewAllPopup
          title={"Schedule history"}
          subtitle={
            "All scheduled transaction related to beneficiary are listed below."
          }
          closeCallback={() => setShowScheduleCategoryPopup(false)}
          type={"category"}
          payload={scheduleCategory}
        />
      )}
      {showScheduleConfidentialPopup && (
        <ScheduleTransactionViewAllPopup
          title={"Confidential history"}
          subtitle={
            "All scheduled transaction related to beneficiary are listed below."
          }
          closeCallback={() => setShowScheduleConfidentialPopup(false)}
          type={"confidential"}
          payload={{
            id: scheduleBeneId,
            number: scheduleBeneAcctNumber,
            name: scheduleBeneName,
            schedule_acc_name: scheduleBeneName,
          }}
        />
      )}
      {!isPopup && (
        <>
          <div className="sched-mobile-nav-bar fixed top-top-base left-left-base mt-margin-base w-width-full z-z-index-header bg-primary-nav shadow-box-shadow-bottom Qmd:hidden block">
            <div
              className="px-padding-md py-padding-sm flex flex-row items-center gap-gap-sm"
              onClick={() => {
                navigate(-1);
              }}
            >
              <SVGComponent
                url={ICONS?.ARROW_LEFT_WHITE}
                height="var(--icon-sm)"
                width="var(--icon-sm)"
                color="var(--text-primary)"
                alt="MobileBackIcon"
              />

              <div className="flex flex-col justify-center items-start">
                <div className="text-font-md text-text-primary font-normal font-sans">
                  Schedule Transaction
                </div>
                <div className="text-font-xs text-text-secondary font-semibold font-sans">
                  Schedule detail
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="flex flex-col Qmd:h-full-height bg-primary-nav">
        <div>
          <div
            className={`${
              isPopup
                ? "hidden"
                : "h-mobile-navbar-height Qmd:h-navbar-breadcrumb-height flex Qmd:flex-shrink-0"
            }`}
          ></div>
          <div className="h-auto bg-primary-nav Qmd:flex Qmd:flex-row justify-center relative">
            <div className="sched-detail-section-inner-1024 w-auto Qmd:max-w-screen-Qlg Qmd:w-std-width relative">
              <div className="h-auto flex flex-col Qmd:flex-row justify-center w-width-full ">
                <div
                  className={`w-width-full Qmd:w-width-md flex flex-row justify-start items-center px-padding-md Qmd:pl-padding-sm py-padding-md Qmd:pr-padding-md ${isPopup ? "" : "mt-margin-sm Qmd:mt-margin-base"}`}
                >
                  <TitleSubtitlePair
                    title={scheduleName}
                    variant="md"
                    subtitle="Schedule name"
                    titleColor="text-primary"
                  />
                </div>

                <hr className="border-primary-bg relative z-z-index-content Qmd:hidden mx-margin-md Qlg:mx-margin-base"></hr>

                <div className="hidden  Qmd:block border-r border-solid pl-padding-xs border-primary-bg my-margin-md"></div>

                <div className="sched-txn-amount-div w-width-lg py-padding-md Qmd:py-padding-base flex Qmd:flex-row justify-between items-stretch text-text-primary Qmd:w-width-lg">
                  <div className="sched-txn-amount flex flex-col items-start pl-padding-md self-center">
                    <TitleSubtitlePair
                      title={
                        scheduleAmt
                          ? `INR ${FormatAmount({ price: scheduleAmt })}`
                          : "N/A"
                      }
                      subtitle="Amount"
                      titleColor={scheduleAmt ? "settled" : "text-primary"}
                      isBold={true}
                    />
                  </div>

                  <div className="flex flex-row">
                    <div
                      className={` ${
                        isScheduleConfidential
                          ? " border-r border-primary-bg"
                          : "w-auto h-height-full"
                      } hidden Qmd:flex flex-row justify-evenly items-center `}
                    >
                      {isScheduleConfidential && (
                        <>
                          <TopNavSmallButton
                            btnText={
                              <>
                                {globalText?.CONFIDENTIAL}
                                <br />
                                {globalText?.TRANSACTION}
                              </>
                            }
                            btnType="button"
                            handleFunction={() =>
                              isPopup
                                ? CommonToast({
                                    text: "Action restricted in popup mode.",
                                    icon: ICONS?.ERROR_WHITE_CIRCLE,
                                    variant: "var(--error)",
                                    btnProps: {
                                      isDisabled: false,
                                      enabledTextColor: "var(--text-primary)",
                                      enabledBgColor: "var(--primary-bg)",
                                    },
                                  })
                                : setShowScheduleConfidentialPopup(true)
                            }
                            isDisabled={isPopup}
                            enabledTextColor="var(--text-primary)"
                            enabledBgColor="var(--primary-nav-act)"
                            disabledBgColor="var(--primary-nav-act)"
                            icon={ICONS?.CONFIDENTIAL_TRANSACTION}
                            hoverOption="white"
                            fullWidthRequired={false}
                          />
                        </>
                      )}
                    </div>
                    <div className="hidden Qmd:flex flex-row">
                      <TopNavSmallButton
                        btnText={
                          <>
                            {globalText?.SCHEDULE} <br /> {globalText?.HISTORY}
                          </>
                        }
                        btnType="button"
                        handleFunction={() =>
                          isPopup
                            ? CommonToast({
                                text: "Action restricted in popup mode.",
                                icon: ICONS?.ERROR_WHITE_CIRCLE,
                                variant: "var(--error)",
                                btnProps: {
                                  isDisabled: false,
                                  enabledTextColor: "var(--text-primary)",
                                  enabledBgColor: "var(--primary-bg)",
                                },
                              })
                            : setShowScheduleHistoryPopup(true)
                        }
                        isDisabled={isPopup}
                        enabledTextColor="var(--text-primary)"
                        enabledBgColor="var(--primary-nav-act)"
                        disabledBgColor="var(--primary-nav-act)"
                        icon={ICONS?.TRANSACTION_HISTORY}
                        hoverOption="white"
                        fullWidthRequired={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <hr className="border-primary-bg relative z-z-index-content mx-margin-md Qlg:mx-margin-base"></hr>
              <div className="flex flex-col Qmd:flex-row justify-center w-width-full">
                <div className="text-text-primary Qmd:w-width-md flex flex-col items-center justify-between">
                  <div className="flex flex-row items-center justify-between w-width-full px-padding-sm pt-padding-sm Qmd:p-padding-base Qmd:pt-padding-md">
                    <TitleSubtitlePair
                      isDisabled={!services?.includes("VAccount") || isPopup}
                      alignRight={false}
                      title={formatAccountNumber(scheduleSrcAcctNumber)}
                      titleColor={"text-primary"}
                      subtitle={"Source account"}
                      onClick={() => {
                        if (!services?.includes("VAccount")) {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "VAccount",
                            },
                          });
                        } else if (isPopup) {
                          CommonToast({
                            text: "Action restricted in popup mode.",
                            icon: ICONS?.ERROR_WHITE_CIRCLE,
                            variant: "var(--error)",
                            btnProps: {
                              isDisabled: false,
                              enabledTextColor: "var(--text-primary)",
                              enabledBgColor: "var(--primary-bg)",
                            },
                          });
                        } else {
                          navigate(
                            `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${
                              scheduleSrcId
                            }`,
                          );
                        }
                      }}
                      info={false}
                      showArrow={true}
                      hoverOption={"white"}
                      isBold={false}
                      variant={"md"}
                    />

                    <CommonBankLogo
                      ifsc={scheduleSrcIFSC}
                      variant="big"
                      type="pill"
                    />
                  </div>
                  <div className="hidden Qmd:flex flex-row justify-between items-center w-width-full Qmd:pb-padding-md Qmd:pl-padding-sm">
                    <TitleSubtitlePair
                      isDisabled={false}
                      alignRight={false}
                      title={scheduleSrcIFSC}
                      titleColor={"text-primary"}
                      subtitle={"IFSC code"}
                      info={false}
                      showArrow={false}
                      isBold={false}
                      variant={"md"}
                    />

                    <TitleSubtitlePair
                      isDisabled={false}
                      textAlign={"right"}
                      title={schedulePaymentMethod}
                      titleColor={"text-primary"}
                      subtitle={"Payment method"}
                      info={false}
                      showArrow={false}
                      isBold={false}
                      variant={"md"}
                    />
                  </div>
                </div>
                <div className="w-icon-md my-auto h-height-base Qmd:h-stepper-header flex flex-col justify-around items-center mx-auto Qmd:mx-margin-base Qmd:ml-margin-xs">
                  <div className="hidden  Qmd:block verical-filler border-r border-primary-bg h-height-sm"></div>
                  <div className="hidden Qmd:flex arrow-icon h-icon-md w-icon-md">
                    <img
                      src={ICONS?.ARROW_RIGHT_BLUE_CIRCLE}
                      className="w-icon-md h-icon-md"
                      alt="arrow"
                    />
                  </div>

                  <div className="hidden  Qmd:block verical-filler border-r border-primary-bg h-height-sm"></div>
                </div>
                <div className="flex items-center gap-gap-sm justify-start Qlg:px-padding-md Qmd:hidden mx-margin-md Qlg:mx-margin-base">
                  <div className="w-width-md border-b border-primary-bg"></div>
                  <div className="w-icon-md">
                    <img
                      src={ICONS?.ARROW_DOWN_BLUE_WHITE}
                      alt="arrowDownBlueWhite"
                    />
                  </div>
                  <div className="w-width-md border-b border-primary-bg"></div>
                </div>
                <div className="text-text-primary w-width-full Qmd:w-width-lg flex flex-col items-start justify-between">
                  <div className="flex flex-row w-width-full justify-between">
                    <div className="flex flex-col gap-gap-sm w-width-full">
                      <div className="flex flex-row w-width-full justify-between px-padding-sm Qmd:px-padding-base gap-gap-sm  items-center pt-padding-sm Qmd:pt-padding-md">
                        <TitleSubtitlePair
                          isDisabled={
                            !services?.includes("BVAccount") || isPopup
                          }
                          alignRight={false}
                          title={formatAccountNumber(scheduleBeneAcctNumber)}
                          titleColor={"text-primary"}
                          subtitle={"Beneficiary account"}
                          onClick={() => {
                            if (!services?.includes("BVAccount")) {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "BVAccount",
                                },
                              });
                            } else if (isPopup) {
                              CommonToast({
                                text: "Action restricted in popup mode.",
                                icon: ICONS?.ERROR_WHITE_CIRCLE,
                                variant: "var(--error)",
                                btnProps: {
                                  isDisabled: false,
                                  enabledTextColor: "var(--text-primary)",
                                  enabledBgColor: "var(--primary-bg)",
                                },
                              });
                            } else {
                              navigate(
                                `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${scheduleBeneId}`,
                              );
                            }
                          }}
                          info={false}
                          showArrow={true}
                          hoverOption={"white"}
                          isBold={false}
                          variant={"md"}
                        />

                        <div className="Qsmd:mr-margin-md">
                          <CommonBankLogo
                            ifsc={scheduleBeneIFSC}
                            variant="big"
                            type="pill"
                          />
                        </div>
                      </div>
                      <hr className="border-primary-bg relative z-z-index-content Qmd:hidden mx-margin-md Qlg:mx-margin-base"></hr>
                      <div className="pl-padding-md pt-padding-sm pb-padding-md Qmd:hidden">
                        <TitleSubtitlePair
                          isDisabled={false}
                          title={schedulePaymentMethod}
                          titleColor={"text-primary"}
                          subtitle={"Payment method"}
                          info={false}
                          showArrow={false}
                          isBold={false}
                          variant={"md"}
                        />
                      </div>
                    </div>

                    <div className="hidden Qmd:flex">
                      <TopNavSmallButton
                        btnText={scheduleCategory}
                        btnType="button"
                        handleFunction={() =>
                          isPopup
                            ? CommonToast({
                                text: "Action restricted in popup mode.",
                                icon: ICONS?.ERROR_WHITE_CIRCLE,
                                variant: "var(--error)",
                                btnProps: {
                                  isDisabled: false,
                                  enabledTextColor: "var(--text-primary)",
                                  enabledBgColor: "var(--primary-bg)",
                                },
                              })
                            : setShowScheduleCategoryPopup(true)
                        }
                        isDisabled={isPopup}
                        enabledTextColor="var(--text-primary)"
                        enabledBgColor="var(--primary-nav-act)"
                        disabledBgColor="var(--primary-nav-act)"
                        icon={categoryMapper(scheduleCategory)}
                        hoverOption="white"
                        fullWidthRequired={false}
                      />
                    </div>
                  </div>

                  <div className="hidden Qmd:flex flex-row justify-between items-center gap-gap-xl w-width-full Qmd:items-end">
                    <div className="pl-padding-sm pt-padding-md Qmd:pb-padding-md ">
                      <TitleSubtitlePair
                        isDisabled={false}
                        alignRight={false}
                        title={scheduleBeneIFSC}
                        titleColor={"text-primary"}
                        subtitle={"IFSC code"}
                        info={false}
                        showArrow={false}
                        isBold={false}
                        variant={"md"}
                      />
                    </div>
                    <div className="w-icon-md"></div>
                    <div className="flex flex-row">
                      <div className="border-t border-primary-bg">
                        {!scheduleDeleted && (
                          <>
                            <div className="hidden Qmd:flex">
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    {globalText?.DISCARD} <br />{" "}
                                    {globalText?.SCHEDULE}
                                  </>
                                }
                                btnType="button"
                                handleFunction={() => {
                                  if (isPopup) {
                                    CommonToast({
                                      text: "Action restricted in popup mode.",
                                      icon: ICONS?.ERROR_WHITE_CIRCLE,
                                      variant: "var(--error)",
                                      btnProps: {
                                        isDisabled: false,
                                        enabledTextColor: "var(--text-primary)",
                                        enabledBgColor: "var(--primary-bg)",
                                      },
                                    });
                                  } else if (hasModService) {
                                    setShowPromptModal(true);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "BAScheduledTxn",
                                      },
                                    });
                                  }
                                }}
                                isDisabled={!hasModService || isPopup}
                                enabledTextColor="var(--text-primary)"
                                enabledBgColor="var(--primary-nav-act)"
                                disabledBgColor="var(--primary-nav-act)"
                                icon={ICONS?.DISCARD_WITH_WHITE_CIRCLE}
                                hoverOption="white"
                                fullWidthRequired={false}
                              />
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="block Qsmd:hidden">
              {!(isScheduleApproved || scheduleDeleted) && (
                <TimelineStatusBar
                  overrideAutoLoader
                  showMobile={true}
                  whichBtnClicked={btnClicked?.[scheduleId] || "none"}
                  failedToTakeaction={
                    !!scheduleApproveFailed || schedulesTxnRejectError
                  }
                  failedToTakeIcon={true}
                  failedToTakeactionReason={
                    scheduleApproveFailedMessage ||
                    schedulesTxnRejectError?.errors?.base?.[0]?.errors?.[0]
                  }
                  rejected={isScheduleRejected && !scheduleDeleted}
                  rejectedReason={scheduleRejectMessage}
                  accountApprovalPending={
                    !isScheduleApproved &&
                    !scheduleDeleted &&
                    !scheduleBeneApproved
                  }
                  handleApprovalPendingBtn={() =>
                    services?.includes("BAAccount")
                      ? setShowBeneAccModal(true)
                      : navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "BAAccount",
                          },
                        })
                  }
                  isApprovalPendingDisabled={
                    !services?.includes("AInternalTxn")
                  }
                  pending={
                    !isScheduleApproved &&
                    !scheduleDeleted &&
                    scheduleBeneApproved
                  }
                  accountApprovalPendingSubHeader={
                    services?.includes("BAScheduledTxn")
                      ? "Account is not approved, approve account before approving transaction."
                      : "To approve the account, please contact the authorized person."
                  }
                  rejectMobClick={() => {
                    if (hasModService) {
                      setbtnClicked((prev) => ({
                        ...prev,
                        [scheduleId]: "Reject",
                      }));
                      setShowRejectPrompt(true);
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "BAScheduledTxn",
                        },
                      });
                    }
                  }}
                  isRejectMobDisable={!hasModService}
                  approveMobClick={onApproveClick}
                  isApproveMobDisable={!hasModService}
                  rejectBtnText={
                    <>
                      Reject <br /> Schedule
                    </>
                  }
                  approveBtnText={
                    <>
                      Approve <br /> Schedule
                    </>
                  }
                />
              )}
            </div>
          </div>
        </div>
        <div className="h-full-height flex flex-row justify-center bg-primary-bg Qmd:flex-1 pb-padding-xl">
          <div className="sched-bottom-section-inner-1024 max-w-screen-Qlg w-max-content-width">
            <div className="block Qmd:hidden">{quickActions}</div>
            <>
              <div
                className={`h-auto flex flex-row mt-margin-md ml-margin-md Qsmd:ml-margin-base ${
                  !(isScheduleApproved || isScheduleRejected || scheduleDeleted)
                    ? "Qsmd:justify-center justify-start"
                    : "justify-start"
                } items-end`}
              >
                <div
                  className={`relative w-timeline-status-card-width h-height-full bg-primary-card rounded-l-border-radius-md rounded-tr-border-radius-md  ${
                    isScheduleApproved || scheduleDeleted
                      ? "rounded-br-border-radius-md"
                      : "rounded-br-border-radius-md Qsmd:rounded-br-none"
                  }`}
                >
                  <div className="w-width-full h-height-full text-text-primary bg-primary-nav relative rounded-border-radius-md">
                    <div className="text-font-xs py-padding-sm px-padding-md font-semibold">
                      Schedule timeline
                    </div>
                    <hr className="relative left-left-base border-primary-bg border-t-border mx-margin-md" />

                    <div ref={leftContentRef}>
                      <CommonTimeLineCard
                        logsData={scheduleUpdatedData?.transaction}
                        handleApprovalClick={handleTimelinePopup}
                        showApprovalTimeline={true}
                        showDistributionTimeline={false}
                        showDistributionRightIcon={true}
                        showApprovalLeftIcon={true}
                        showApprovalDuration={true}
                        cardType={"single"}
                        isDisabled={isPopup ? true : false}
                        leftCardTitle="Stage - Approval"
                      />
                    </div>
                  </div>
                </div>
                <div className="hidden Qmd:flex flex-col flex-grow w-width-md">
                  {/* Web  */}
                  {scheduleUpdatedData?.transaction?.map((txn) => {
                    return (
                      <TimelineStatusBar
                        overrideAutoLoader
                        hasDistributionData={false}
                        showMobile={false}
                        failedToTakeaction={
                          !!scheduleApproveFailed || schedulesTxnRejectError
                        }
                        failedToTakeIcon={true}
                        failedToTakeactionReason={
                          scheduleApproveFailedMessage ||
                          schedulesTxnRejectError?.errors?.base?.[0]
                            ?.errors?.[0]
                        }
                        rejected={isScheduleRejected && !scheduleDeleted}
                        rejectedReason={scheduleRejectMessage}
                        accountApprovalPending={
                          !isScheduleApproved &&
                          !scheduleDeleted &&
                          !scheduleBeneApproved
                        }
                        handleApprovalPendingBtn={() =>
                          services?.includes("BAAccount")
                            ? setShowBeneAccModal(true)
                            : navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "BAAccount",
                                },
                              })
                        }
                        isApprovalPendingDisabled={
                          !services?.includes("AInternalTxn")
                        }
                        pending={
                          !isScheduleApproved &&
                          !scheduleDeleted &&
                          scheduleBeneApproved
                        }
                        rejectClick={() => {
                          if (hasModService) {
                            setbtnClicked((prev) => ({
                              ...prev,
                              [scheduleId]: "Reject",
                            }));
                            setShowRejectPrompt(true);
                          } else {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "BAScheduledTxn",
                              },
                            });
                          }
                        }}
                        isRejectDisable={!hasModService}
                        approveClick={onApproveClick}
                        isApproveDisable={!hasModService}
                        whichBtnClicked={btnClicked?.[scheduleId] || "none"}
                        accountApprovalPendingSubHeader={
                          services?.includes("BAScheduledTxn")
                            ? "Account is not approved, approve account before approving transaction."
                            : "To approve the account, please contact the authorized person."
                        }
                        rejectBtnText={
                          <>
                            Reject <br /> Schedule
                          </>
                        }
                        approveBtnText={
                          <>
                            Approve <br /> Schedule
                          </>
                        }
                      />
                    );
                  })}
                </div>
              </div>
            </>
            <div className="sched-detail-container w-width-full max-w-screen-Qlg bg-primary-bg px-padding-md Qmd:px-padding-base overflow-x-hidden">
              <>
                <div className="py-padding-md flex">
                  <div className="flex gap-gap-sm bg-primary-card w-auto rounded-border-radius-md">
                    <SwitcherTabs
                      initialActiveTab={
                        isPopup ? "additional details" : "details"
                      }
                      tabs={[
                        {
                          label: "Details",
                          key: "details",
                          handler: handleShowDetails,
                        },
                        {
                          label: "Additional Details",
                          key: "additional details",
                          handler: handleShowAdditionalDetails,
                        },
                        ...(scheduleBeneTxnList.length >
                        GlobalConfiguration?.lengthCheckZero
                          ? [
                              {
                                label: "Transaction Created",
                                key: "transaction created",
                                handler: handleTransactionCreated,
                              },
                            ]
                          : []),
                      ]}
                      setIndex={setIndex}
                    />
                  </div>
                </div>
              </>
              <div className="relative">
                {index === GlobalConfiguration?.lengthCheckZero && (
                  <div className={animationClass}>
                    <div className="flex flex-col items-center Qmd:items-start Qmd:flex-row gap-gap-md pb-padding-md Qmd:pb-padding-base">
                      <CommonDetailCard
                        cardTitle="Transfer details"
                        variant="third"
                        numCols={GlobalConfiguration?.lengthCheckOne}
                        entries={[
                          {
                            content: [
                              scheduleFrequency.split("_").join(" "),
                            ].map(
                              (s) =>
                                s
                                  .charAt(GlobalConfiguration?.lengthCheckZero)
                                  .toUpperCase() +
                                s.slice(GlobalConfiguration?.lengthCheckOne),
                            ),
                            heading: "Frequency",
                            type: "text",
                          },
                          {
                            content: scheduleStartDate
                              ? formatDate(scheduleStartDate)
                              : "—",
                            heading: "Schedule start date",
                            type: "text",
                          },
                          {
                            content: scheduleEndDate
                              ? formatDate(scheduleEndDate)
                              : "—",
                            heading: "Schedule end date",
                            type: "text",
                          },
                          {
                            content: scheduleTimeSlot
                              ? formatTimeSlot(scheduleTimeSlot)
                              : "—",
                            heading: "Time slot",
                            type: "text",
                          },
                          {
                            content: scheduleOccurrences,
                            heading: "Occurrences",
                            onClick: () => {
                              if (isPopup) {
                                CommonToast({
                                  text: "Action restricted in popup mode.",
                                  icon: ICONS?.ERROR_WHITE_CIRCLE,
                                  variant: "var(--error)",
                                  btnProps: {
                                    isDisabled: false,
                                    enabledTextColor: "var(--text-primary)",
                                    enabledBgColor: "var(--primary-bg)",
                                  },
                                });
                              } else if (hasOccurrenceService) {
                                handleShowOccurrences();
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "BOScheduledTxn",
                                  },
                                });
                              }
                            },
                            isDisabled: !hasOccurrenceService || isPopup,
                            type: "text",
                          },
                        ]}
                      />

                      <CommonDetailCard
                        cardTitle="Origin details"
                        variant="third"
                        numCols={GlobalConfiguration?.lengthCheckOne}
                        entries={[
                          {
                            content: scheduleCreatedBy ?? "—",
                            heading: "Created by",
                            type: "text",
                          },
                          {
                            content: scheduleCreatedOn
                              ? formatDateViewAll(scheduleCreatedOn, true, true)
                              : "—",
                            heading: "Created on",
                            type: "text",
                          },
                        ]}
                      />
                    </div>
                  </div>
                )}

                {index === GlobalConfiguration?.lengthCheckOne &&
                  detailSectionAdditionalDetailsDiv}

                {index === GlobalConfiguration?.lengthCheckTwo && (
                  <div className={animationClass}>
                    <div className="flex flex-col Qmd:flex-row gap-y-gap-md gap-x-gap-sm flex-wrap pb-padding-md">
                      {isloading ? (
                        <div className="w-width-full flex justify-center items-center">
                          <Loader />
                        </div>
                      ) : (
                        <BeneTransactionGridView
                          data={transactionData?.payload?.transactions}
                          typepop={"schedDetailViewAll"}
                        />
                      )}
                    </div>
                    <div className="h-height-full" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleBeneficiaryTransactionDetails;
